import React from "react"

export default class Message extends React.Component {
	
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className="Message" dangerouslySetInnerHTML={{__html: this.props.message.html}}></div>
		)
	}

}